/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: 0WZFGqgrkZcg
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import SeparatorVertical from "../../SeparatorVertical"; // plasmic-import: gHGPazbS0-f7/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebTabSideNav.module.css"; // plasmic-import: 0WZFGqgrkZcg/css

createPlasmicElementProxy;

export const PlasmicWebTabSideNav__VariantProps = new Array();

export const PlasmicWebTabSideNav__ArgProps = new Array("tabs");

const $$ = {};

function PlasmicWebTabSideNav__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"sidenav"}
      data-plasmic-override={overrides.sidenav}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.sidenav
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        <div
          data-plasmic-name={"tabsButtons"}
          data-plasmic-override={overrides.tabsButtons}
          className={classNames(projectcss.all, sty.tabsButtons)}
        >
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.tabs
          })}
        </div>
      </div>
      <SeparatorVertical
        data-plasmic-name={"separatorVertical"}
        data-plasmic-override={overrides.separatorVertical}
        className={classNames("__wab_instance", sty.separatorVertical)}
        color={"uiSeparator"}
      />
    </div>
  );
}

const PlasmicDescendants = {
  sidenav: ["sidenav", "freeBox", "tabsButtons", "separatorVertical"],
  freeBox: ["freeBox", "tabsButtons"],
  tabsButtons: ["tabsButtons"],
  separatorVertical: ["separatorVertical"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebTabSideNav__ArgProps,
          internalVariantPropNames: PlasmicWebTabSideNav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebTabSideNav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "sidenav") {
    func.displayName = "PlasmicWebTabSideNav";
  } else {
    func.displayName = `PlasmicWebTabSideNav.${nodeName}`;
  }
  return func;
}

export const PlasmicWebTabSideNav = Object.assign(
  // Top-level PlasmicWebTabSideNav renders the root element
  makeNodeComponent("sidenav"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    tabsButtons: makeNodeComponent("tabsButtons"),
    separatorVertical: makeNodeComponent("separatorVertical"),
    // Metadata about props expected for PlasmicWebTabSideNav
    internalVariantProps: PlasmicWebTabSideNav__VariantProps,
    internalArgProps: PlasmicWebTabSideNav__ArgProps
  }
);

export default PlasmicWebTabSideNav;
/* prettier-ignore-end */
